import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { $DiscoverBreadcrumbs } from 'shared/atoms';
import {
  $CurrentAvailableDiscoverDataOrNull,
  $CurrentDiscoverKeyword,
  $CurrentDiscoverStandardKeyword,
} from '@discover/shared/atom';

export const useDiscoverTitle = (): string => {
  const keyword = useAtomValue($CurrentDiscoverKeyword);
  const standardKeyword = useAtomValue($CurrentDiscoverStandardKeyword);

  const { breadcrumbs = '' } = useAtomValue($DiscoverBreadcrumbs(keyword as string));
  const data = useAtomValue($CurrentAvailableDiscoverDataOrNull);
  const { t } = useTranslation();

  if (!data) {
    return '';
  }

  const articles = data.article_v2.items;
  let discoverTitle = `${t('seo_kep_title').replace('seo_kep_query', standardKeyword || '')}`;

  if (breadcrumbs && articles.length > 0) {
    const thisYear = new Date().getFullYear().toString();

    discoverTitle = `${t('seo_product_page_title')
      .replace('%d', articles.length.toString())
      .replace('{keyword}', standardKeyword || '')
      .replace('%s', thisYear)}`;
  }

  return discoverTitle;
};
